import { trace } from 'rytm-helpers'
import Controller from './Controller'
import MagicGrid from "magic-grid"
import { remToPx } from './../shared/affix-fafix'

class MagicGridController extends Controller {
  
  /**
  * on view Swap complete - just before SHOW
  * @param {Event} e
  **/
  onViewSwapComplete(e) {
    super.onViewSwapComplete(e)
    this.initMagicGrid()
  }
  addEventListeners() {
    super.addEventListeners()
    if (this.magicGrid) {
      this.magicGrid.positionItems();
    }
  }
  removeEventListeners() {
    super.removeEventListeners()
  }

  /**
   * OWN
   */
  
  initMagicGrid() {
    const container = document.querySelector(this.getContainerSelector())
    const listWrapper = container.querySelector("div[data-grid-items]")
    if (listWrapper) {
      // const items = listWrapper.dataset.gridItems
      this.magicGrid = new MagicGrid({
        container: listWrapper,
        static: true,
        gutter: 30,
        animate: false
      })
      this.magicGrid.listen()
    }
  }


}

export default MagicGridController;